import PropTypes from 'prop-types';

import consultationCategoryProp from 'PropTypes/consultationProps';

import {
  consultationScoringImages,
  introHeroTitle,
  scoringSectionDescription,
} from 'assets/content/prescription/content';

// TODO: move to components folder if we decide to drop prescription pages and keep scoring
import HairProfile from '../../Prescription/Components/HairProfile';
// TODO: move to components folder if we decide to drop prescription pages and keep scoring
import IntroHero from '../../Prescription/Components/IntroHero';
import QuestionLayout from './QuestionLayout';

const Scoring = ({ consultationCategory, scoring, submit, userName, onScoringSelectChange }) => {
  const introTitle = `${userName}, ${introHeroTitle}`;
  return (
    <QuestionLayout
      addFooter
      consultationCategory={consultationCategory}
      showProgressTracker={false}
      submit={submit}
      tipContent={null}
    >
      <IntroHero
        description={scoringSectionDescription}
        imageSet={consultationScoringImages}
        title={introTitle}
      >
        <HairProfile onScoringSelectChange={onScoringSelectChange} scoring={scoring} />
      </IntroHero>
    </QuestionLayout>
  );
};

Scoring.defaultProps = {
  userName: '',
  onScoringSelectChange: null,
};

Scoring.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  scoring: PropTypes.shape({
    sensitivity: PropTypes.number.isRequired,
    sebum: PropTypes.number.isRequired,
    dandruff: PropTypes.number.isRequired,
    dryness: PropTypes.number.isRequired,
    damaged: PropTypes.number.isRequired,
    stress: PropTypes.number,
  }).isRequired,
  submit: PropTypes.func.isRequired,
  onScoringSelectChange: PropTypes.func,
  userName: PropTypes.string,
};

export default Scoring;
